import { UrlApi } from "../../../services/apirest";

// Pantallas/módulos de envasados (valor del campo "donde")
export const DONDE = {
  PEDIDOS: "Pedidos",
  CLIENTES: "Clientes",
  RENDICIONES: "Rendiciones",
  PRECIOS: "Precios",
  FACTURACION: "Facturación",
  POSNETS: "Posnets choferes",
  // se agregan a medida que se instrumentan pantallas
};

// Registra una acción del usuario. Nunca lanza error: si el log falla,
// la acción del usuario no se ve afectada.
export const registrarAccion = (donde, accion) => {
  fetch(UrlApi + "/envasado_log_acciones", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      usuario: localStorage.getItem("user"),
      donde,
      accion,
    }),
  }).catch((err) => console.error("No se pudo registrar la acción:", err));
};

// Arma un texto con los campos que cambiaron entre "antes" y "despues".
// etiquetas: { campo_bd: "Nombre legible" }. Solo compara los campos de etiquetas.
export const describirCambios = (antes = {}, despues = {}, etiquetas = {}) => {
  const formatear = (v) => (v === null || v === undefined || v === "" ? "(vacío)" : String(v));

  return Object.keys(etiquetas)
    .filter((campo) => campo in despues && formatear(antes[campo]) !== formatear(despues[campo]))
    .map((campo) => `${etiquetas[campo]}: ${formatear(antes[campo])} → ${formatear(despues[campo])}`)
    .join(", ");
};
